
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/entities/page-request'
import CommonTable from '@/components/common-table/index.vue'
import User from '@/entities/user'
import TableAction from '@/entities/table-action'
import CardBody from '@/components/card-body/index.vue'
import SortDropdown from '@/components/sort-dropdown/index.vue'
import DolistPanel from '@views/proof/dolist/panel.vue'
import { ElTable } from 'element-ui/types/table'
import Dolist from '@/entities/dolist'
import tableSort from '@/mixins/table-sort'
import dictAction from '@/mixins/dict-action'
import workzone from '@/mixins/workzone'
import _ from 'lodash'
import config from '@/config'
import dayjs from 'dayjs'
import util from '@/lib/util'

class PageListRequest extends PageRequest {
  type: string
  workZoneCode: string
  constructor() {
    super()
    this.type = 'DO'
  }
}

@Component({
  components: {
    CommonTable,
    CardBody,
    SortDropdown,
    DolistPanel
  },
  mixins: [tableSort, dictAction, workzone]
})
export default class DolistMaster extends AbpBase
  implements TableAction<Dolist> {
  [x: string]: any
  pagerequest: PageListRequest = new PageListRequest()

  isPanelExpand: boolean = false
  isExporting: boolean = false

  selectItem: Dolist = null

  dictEpodDoMaster = 'epod_do_master'

  get tableLoading() {
    return this.$store.state.dolist.loading
  }

  get tableDataList() {
    return this.$store.state.dolist.list
  }

  get tablePagination() {
    return {
      pageNo: this.$store.state.dolist.currentPage,
      pageSize: this.$store.state.dolist.pageSize,
      total: this.$store.state.dolist.totalCount
    }
  }

  @Watch('hideWorkZoneFilter', { deep: true, immediate: true })
  onWorkZoneFilterHiddenChange(val) {
    this.$set(
      this.table,
      'height',
      val
        ? `calc(${config.commonTableHeight} - 20px)`
        : `calc(${config.commonTableHeight})`
    )
  }

  table = this.$standardTableData({
    hideHeader: false,
    title: this.L('Dolist'),
    query: {
      workZoneCode: null
    },
    searchData: [
      {
        type: 'select',
        model: 'workZoneCode',
        title: 'WorkZone',
        key: 'WorkZone',
        clearable: true,
        filterable: true,
        option: [],
        hide: true
      },
      {
        type: 'input',
        title: 'keyword',
        clearable: true,
        hide: true
      }
    ],
    columns: [
      {
        key: 'collapseColumn',
        hide: true,
        render: (h: any, ctx: any) => {
          return h(
            'span',
            this.getTableRef().$scopedSlots.collapseColumn(ctx.row)
          )
        }
      },
      {
        title: this.L('Date'),
        sortable: true,
        key: 'creationTime',
        render: (h: any, ctx: any) => {
          return h(
            'span',
            this.getTableRef().$scopedSlots.creationTime(ctx.row)
          )
        }
      },
      {
        title: this.L('DO Number'),
        sortable: true,
        key: 'doNo'
      },
      {
        title: this.L('Store Code'),
        sortable: true,
        key: 'shipToCode'
      },
      {
        title: this.L('DO Category'),
        sortable: true,
        key: 'doCategory',
        render: (h: any, ctx: any) => {
          return h('span', this.getTableRef().$scopedSlots.doCategory(ctx.row))
        }
      },
      {
        title: this.L('Proposed Schedule'),
        key: 'proposedSchedule',
        sortable: true,
        width: 180,
        render: (h: any, ctx: any) => {
          return h(
            'span',
            this.getTableRef().$scopedSlots.proposedSchedule(ctx.row)
          )
        }
      },
      {
        title: this.L('E.T.A'),
        sortable: true,
        key: 'estimateArrival',
        render: (h: any, ctx: any) => {
          return h(
            'span',
            this.getTableRef().$scopedSlots.estimateArrival(ctx.row)
          )
        }
      },
      {
        title: 'Truck No',
        sortable: true,
        key: 'vehicleNo'
      },
      {
        title: this.L('Status'),
        sortable: true,
        key: 'status',
        render: (h: any, ctx: any) => {
          return h('span', this.getTableRef().$scopedSlots.status(ctx.row))
        }
      }
    ]
  })

  async doTableSearch() {
    this.pagerequest.maxResultCount = this.tablePagination.pageSize
    this.pagerequest.skipCount =
      (this.tablePagination.pageNo - 1) * this.tablePagination.pageSize
    this.pagerequest.workZoneCode =
      this.workZone === 'ALL' ? this.table.query.workZoneCode : this.workZone
    await this.$store.dispatch({
      type: 'dolist/getAll',
      data: this.pagerequest
    })
  }

  doTablePageSizeChange(pageSize: number) {
    this.$store.commit('dolist/setPageSize', pageSize)
    this.doTableSearch()
  }

  doTablePageChange(pageNo: number) {
    this.$store.commit('dolist/setCurrentPage', pageNo)
    this.doTableSearch()
  }

  doTableRowClick(rowData: Dolist) {
    this.isPanelExpand = true
    this.selectItem = rowData
  }

  handleTableSort(itemKey, sortBy) {
    if (sortBy === 'none') {
      this.pagerequest.sorting = null
    } else {
      this.pagerequest.sorting = `${itemKey} ${sortBy}`
    }
    this.doTablePageChange(1)
  }

  getTableRef(): ElTable {
    return this.$refs.commonTable as ElTable
  }

  @Watch('isPanelExpand', { immediate: true, deep: true })
  onPanelExpandChange(newVal) {
    if (newVal) {
      this.table.hideHeader = true
      this.table.columns.map(t => {
        t.hide = t.key !== 'collapseColumn'
      })
    } else {
      this.table.hideHeader = false
      this.table.columns.map(t => {
        t.hide = t.key === 'collapseColumn'
      })
    }
  }

  formatTargetTime(targetDate, refDate) {
    return util.formatTargetTime(targetDate, refDate)
  }

  doExpandClose() {
    this.isPanelExpand = false
    this.selectItem = null
  }

  // 可操作动作
  tableActionList = [
    {
      icon: 'el-icon-download',
      key: 'export',
      name: 'Export'
    }
  ]

  async doTableAction() {
    
    if(this.isExporting){
      
      this.$notify.info({
        title: 'Exporting is ongoing',
        message: 'Please wait for a minute...'
      })

      return;
    }

    this.isExporting = true;

    try {
      let fileInfo = await this.$store.dispatch({
        type: 'dolist/dolistExport',
        data: {
          workZoneCode: this.pagerequest.workZoneCode,
          sorting: this.pagerequest.sorting,
          filter: null,
          fileType: 'xlsx',
          type: this.pagerequest.type
        }
      })
      if (!fileInfo) {
        return
      }
      let res = await this.$store.dispatch({
        type: 'app/downloadTempFile',
        data: fileInfo
      })
      util.downloadRawDataToFile(fileInfo.fileName, res.data)
      this.$notify.success({
        title: 'Success',
        message: 'Export Success'
      })
      this.isExporting = false;
    } catch (e) {
      console.log(e)
      this.$notify.error({
        title: 'Failed',
        message: 'Export Failed'
      })
      this.isExporting = false;
    }
  }

  async doUpdateDOId() {
    await this.$store.dispatch({
      type: 'dolist/updateDOId'
    })
  }

  async created() {
    //this.doUpdateDOId()
    this.initTableColumnSort(this.table.columns)
    await this.handleWorkZoneSearchData(this.table)
    this.doTableSearch()
  }
}
